import React from 'react';
import Link from 'gatsby-link';
import styles from './styles.module.css';

import { dataByIds } from '../../../data/glassData.js';

import Square from '../square';
import ItemImage from '../item-image';
import ImagePlaceholder from '../image-placeholder';

export default ({ id, imageSizes }) => (
  <Link to={`/glass/${id}`} className={styles.container}>
    <div className={styles.item}>
      <Square>
        {dataByIds[id].mainImage ? (
          <div className={styles.imageContainer}>
            <ItemImage
              itemId={id}
              imageId={dataByIds[id].mainImage}
              sizeOverride="80-blur"
            />
            <ItemImage
              itemId={id}
              imageId={dataByIds[id].mainImage}
              sizes={imageSizes}
            />
          </div>
        ) : (
          <ImagePlaceholder />
        )}
      </Square>
      <div className={styles.title}>{dataByIds[id].title}</div>
    </div>
  </Link>
);



// WEBPACK FOOTER //
// ./src/components/item-link/index.js